/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Step2Inputs */

const id_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan game ke pustaka Anda.`)
};

const ms_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah permainan ke perpustakaan anda.`)
};

const da_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj spillet til dit bibliotek.`)
};

const de_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie das Spiel Ihrer Bibliothek hinzu.`)
};

const en_us2_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add the game to your library.`)
};

const es_es2_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade el juego a tu biblioteca.`)
};

const es_mx2_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega el juego a tu biblioteca.`)
};

const fil_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idagdag ang laro sa iyong library.`)
};

const fr_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez le jeu à votre bibliothèque.`)
};

const it_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi il gioco alla tua libreria.`)
};

const hu_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add hozzá a játékot a könyvtáradhoz.`)
};

const nl_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg de game toe aan je bibliotheek.`)
};

const no_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legg spillet til i biblioteket ditt.`)
};

const pl_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj grę do swojej biblioteki.`)
};

const pt_br2_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione o jogo à sua biblioteca.`)
};

const pt_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione o jogo à sua biblioteca.`)
};

const ro_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaugă jocul în biblioteca ta.`)
};

const fi_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää peli kirjastoosi.`)
};

const sv_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till spelet i ditt bibliotek.`)
};

const vi_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm game vào thư viện của bạn.`)
};

const tr_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyunu kütüphanenize ekleyin.`)
};

const cs_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidejte hru do své knihovny.`)
};

const bg_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавете играта в библиотеката си.`)
};

const ru_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавьте игру в свою библиотеку.`)
};

const uk_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додайте гру до бібліотеки.`)
};

const ar_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أضف اللعبة إلى مكتبتك.`)
};

const hi_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेम को अपनी लाइब्रेरी में जोड़ें।`)
};

const th_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มเกมในคลังของคุณ`)
};

const ja_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームをライブラリに追加。`)
};

const zh_cn2_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将游戏添加到您的游戏库。`)
};

const zh_hant1_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`將遊戲新增到您的遊戲庫。`)
};

const ko_misc_posts_step2 = /** @type {(inputs: Misc_Posts_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임을 라이브러리에 추가하세요.`)
};

/**
* | output |
* | --- |
* | "Add the game to your library." |
*
* @param {Misc_Posts_Step2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_step2 = /** @type {((inputs?: Misc_Posts_Step2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Step2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_step2(inputs)
	if (locale === "ms") return ms_misc_posts_step2(inputs)
	if (locale === "da") return da_misc_posts_step2(inputs)
	if (locale === "de") return de_misc_posts_step2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_step2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_step2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_step2(inputs)
	if (locale === "fil") return fil_misc_posts_step2(inputs)
	if (locale === "fr") return fr_misc_posts_step2(inputs)
	if (locale === "it") return it_misc_posts_step2(inputs)
	if (locale === "hu") return hu_misc_posts_step2(inputs)
	if (locale === "nl") return nl_misc_posts_step2(inputs)
	if (locale === "no") return no_misc_posts_step2(inputs)
	if (locale === "pl") return pl_misc_posts_step2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_step2(inputs)
	if (locale === "pt") return pt_misc_posts_step2(inputs)
	if (locale === "ro") return ro_misc_posts_step2(inputs)
	if (locale === "fi") return fi_misc_posts_step2(inputs)
	if (locale === "sv") return sv_misc_posts_step2(inputs)
	if (locale === "vi") return vi_misc_posts_step2(inputs)
	if (locale === "tr") return tr_misc_posts_step2(inputs)
	if (locale === "cs") return cs_misc_posts_step2(inputs)
	if (locale === "bg") return bg_misc_posts_step2(inputs)
	if (locale === "ru") return ru_misc_posts_step2(inputs)
	if (locale === "uk") return uk_misc_posts_step2(inputs)
	if (locale === "ar") return ar_misc_posts_step2(inputs)
	if (locale === "hi") return hi_misc_posts_step2(inputs)
	if (locale === "th") return th_misc_posts_step2(inputs)
	if (locale === "ja") return ja_misc_posts_step2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_step2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_step2(inputs)
	return ko_misc_posts_step2(inputs)
});
export { misc_posts_step2 as "misc.posts.step2" }